export enum iptuFormEnum {
    IPTU_ISENÇÃO_VIÚVAS = 'IPTU - ISENÇÃO VIÚVAS',
    IPTU_ISENÇÃO_SEM_FINS_LUCRATIVOS = 'IPTU - ISENÇÃO SEM FINS LUCRATIVOS',
    IPTU_ISENÇÃO_CEDIDO_GRATUITAMENTE = 'IPTU - ISENÇÃO CEDIDO GRATUITAMENTE',
    IPTU_ISENÇÃO_SERVIDOR_PÚBLICO = 'IPTU - ISENÇÃO SERVIDOR PÚBLICO',
    IPTU_ISENÇÃO_LOCADO_NO_MUNICÍPIO = 'IPTU - ISENÇÃO LOCADO NO MUNICÍPIO',
    IPTU_ISENÇÃO_IPTU_DOENÇAS_GRAVES = 'IPTU - ISENÇÃO DE DOENÇAS GRAVES',
    IPTU_REQUERIMENTO_IMUNIDADE_DE_IPTU = 'IPTU - REQUERIMENTO DE IMUNIDADE IPTU',
    IPTU_REQUERIMENTO_DE_IPTU = 'IPTU - REQUERIMENTO DE IPTU'
}

export enum itbiFormEnum {
    ITBI_REQUERIMENTO = 'ITBI - REQUERIMENTO DE ITBI',
    ITBI_SOLICITACAO_NÃO_INCIDENCIA = 'ITBI - SOLICITAÇÃO DE NÃO INCIDÊNCIA',
    ITBI_SOLICITAÇÃO_DE_ISENÇÃO_DE_ITBI = 'ITBI - SOLICITAÇÃO DE ISENÇÃO DE ITBI',
}

export enum seadFormEnum {
    ITBI_REQUERIMENTO = 'ITBI - Requerimento de ITBI'
}

export enum dtiFormEnum {
    DECLARACAO_DE_TRANSMISSAO_IMOBILIARIA = 'DECLARAÇÃO DE TRANSMISSÃO IMOBILIÁRIA (DTI)'
}

export enum alvaraFormEnum {
    SOLICITACAO_ALTERACAO_CADASTRAL_REGULARIZACAO_ALVARA = 'SOLICITAÇÃO DE ALTERAÇÃO CADASTRAL E REGULARIZAÇÃO DE ALVARÁ',
    SOLICITACAO_INSCRICAO_MUNICIPAL_EXPEDICAO_ALVARA = 'SOLICITAÇÃO DE INSCRIÇÃO MUNICIPAL E EXPEDIÇÃO DE ALVARÁ'
}